import { Model } from "../model";

export abstract class AsyncSaveable extends Model {
	private _saving: boolean = false;

	public get saving(): boolean {
		return this._saving;
	}

	public set saving(value) {
		this._saving = value;
		if (value) {
			setTimeout(() => (this.saving = false), 5000);
		}
	}
}
